import { autoinject, transient, useView } from "aurelia-framework";
import { QueriesClientService } from "../../../../../../services/queries/queries-client.services";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { NotificationClientService } from "../../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import * as moment from "moment";
import { SignalClientService } from "@rightship-tech/common-ui/services/basic/signal-client.service";
import { SignalFunctions } from "../../../../../../services/basics/signal-functions";
import { RightShipInspectionClientModel } from "../../../../../../models/rightship-inspections/rightship-inspections.models";
import { BaseHistoryTrail } from "../../../../common/base-history-trail";
import * as DOMPurify from "dompurify";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../../constants/authentication/claims";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject
@transient()
@useView('views/pages/modules/rightship-inspection/steps/rightship-inspection-history-trail/rightship-inspection-history-trail.html')
export class RightShipInspectionHistoryTrail extends BaseHistoryTrail<RightShipInspectionClientModel> {

    public audits: any[] = [];
    canModifyBillingDetails: boolean = false;

    constructor(private queriesClientService: QueriesClientService, notificationClientService: NotificationClientService, i18N: I18N,
        private signalClientService: SignalClientService, userClaimService: UserClaimsService, configService: ConfigService) {
        super(configService, notificationClientService, i18N);
        this.canModifyBillingDetails = userClaimService.hasPermission(Claims.CanModifyBillingDetails);
    }

    protected onActivated() {
        this.refreshData();
    }

    public refreshData(id: number = null) {
        const rightShipInspectionId = id ? id : this.item ? this.item.rightShipInspectionId : null;
        if (rightShipInspectionId)
            this.queriesClientService.getData(`/odata/RightShipAudits/Genesis.GetAudits(entityTypeId=${EntityTypes.RightShipInspection},entityId=${rightShipInspectionId})?$orderby=timestamp desc`).then(x => {
                this.audits =  x && x.value? x.value: [];
            });
    }

    getFormattedDate(date) {
        return moment(date).format('DD MMM YYYY HH:mm');
    }

    attached() {
        this.signalClientService.subscribe(SignalFunctions.rightShipInspectionHistoryChanged, this.onRightShipInspectionHistoryChanged);
    }


    detached() {
        this.signalClientService.unsubscribe(SignalFunctions.rightShipInspectionHistoryChanged, this.onRightShipInspectionHistoryChanged);
    }

    protected onRightShipInspectionHistoryChanged = (params: { rightShipInspectionId: number }) => {
        if (this.item.rightShipInspectionId != params.rightShipInspectionId) return;

        this.refreshData();
    }

    showAction() {
        return true;
    }

    getActionDetails(item) {
        const actionDetails = super.getActionDetails(item);

        const div = document.createElement('div');
        div.innerHTML = DOMPurify.sanitize(actionDetails);

        const spans = div.querySelectorAll("span[data-name='shipSuitable']");

        for (let index = 0; index < spans.length; index++) {
            const span = spans.item(index);
            const value = span.textContent;
            if (value == "True") {
                span.textContent = "Suitable";
            } else if (value == "False") {
                span.textContent = "Unsuitable";
            } else {
                span.textContent = "Unknown";
            }
        }

        const spanLABs = div.querySelectorAll("span[data-name='lengthOfTimeAtBerth']");

        for (let index = 0; index < spanLABs.length; index++) {
            const span = spanLABs.item(index);
            const value = parseFloat(span.textContent);
            const days = Math.floor(value);
            const hours = Math.round((value - days) * 24);
            const lengthOfTimeAtBerthDisplayText = (days > 0 ? `${days} ${(days == 1 ? "day" : "days")}` : "") + (hours > 0 ? ` ${hours} ${(hours == 1 ? "hour" : "hours")}` : "");
            span.textContent = lengthOfTimeAtBerthDisplayText.trim();
        }

        let html = div.innerHTML;

        html = html.replace(/item was modified in RightShipInspectionDeficiencies<br>/g, '');
        html = html.replace(/item added to Invoices<br>/g, '');
        html = html.replace(/item was modified in Invoices<br>/g, '');
        html = html.replace(/<br>([^<>]*?) was set to <span ([^>]*?)data-type="1"([^>]*?)>Not Set<\/span><br>/g, '<br>');
        html = html.replace(/^([^<>]*?) was set to <span ([^>]*?)data-type="1"([^>]*?)>Not Set<\/span><br>/g, '<br>');
        html = html.replace(/<br><br>/g, '<br>');
        return html;
    }
}
